import { useDictStore } from "@/stores/dictStore";

import { PricingStrategy, PriceResult } from "../base/pricing.strategy";

export class TransomHardwarePricingStrategy extends PricingStrategy {
    private dictStore = useDictStore();

    public getPrices(...args: unknown[]): PriceResult {
        const [hardwareTypeCode, hardwareStructureType] = args as string[];

        const pricesFromDict = this.dictStore.findTransomHardwarePrice(
            hardwareTypeCode,
            hardwareStructureType,
        );

        if (!this.validatePricesFromDict(pricesFromDict)) {
            return this.getDefaultPrices();
        }

        return {
            price: pricesFromDict.price!,
            priceB2C: pricesFromDict.priceB2C || 0,
            priceB2B: pricesFromDict.priceB2B || 0,
        };
    }
}
